import { render, staticRenderFns } from "./LMenu.vue?vue&type=template&id=24c363f4&"
import script from "./LMenu.vue?vue&type=script&lang=js&"
export * from "./LMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports